import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const AdSenseAd = ({ 
  adSlot, 
  adFormat = 'auto',
  fullWidthResponsive = true,
  style = {},
  className = ''
}) => {
  const [adBlocked, setAdBlocked] = React.useState(false);
  const [showPlaceholder, setShowPlaceholder] = React.useState(false);
  
  // Check if ads are globally enabled
  const adsEnabled = process.env.REACT_APP_ENABLE_ADS === 'true';
  const adClient = process.env.REACT_APP_ADSENSE_CLIENT || 'ca-pub-2324645161135109';
  
  useEffect(() => {
    // Don't load ads if globally disabled
    if (!adsEnabled) {
      return;
    }
    
    const isPlaceholderSlot = !adSlot || adSlot.toString().startsWith('1234567') || adSlot.toString() === 'your_real_ad_slot_id_here';
    if (isPlaceholderSlot) {
      setShowPlaceholder(true);
      return;
    }
    
    const checkAdBlock = () => {
      try {
        if (!window.adsbygoogle) {
          setAdBlocked(true);
          return;
        }
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        console.log('AdSense blocked by ad blocker');
        setAdBlocked(true);
      }
    };

    const timer = setTimeout(checkAdBlock, 1000);
    return () => clearTimeout(timer);
  }, [adsEnabled, adSlot]);

  // Don't render anything if ads are disabled
  if (!adsEnabled) {
    return null;
  }
  
  // Show placeholder with invalid slots
  if (showPlaceholder) {
    return null;
  }

  if (adBlocked) {
    return null; // Hide ad space when blocked
  }

  return (
    <Box className={className} sx={{ textAlign: 'center', my: 2, ...style }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive}
      />
    </Box>
  );
};

export default AdSenseAd;